// @flow
import * as Sentry from '@sentry/react';
import * as React from 'react';

import Layout from '../components/Layout';
import TextHeader1 from '../components/TextHeader1';
import TextStrong from '../components/TextStrong';
import Checklist from '../components/Checklist';
import type { TProps } from './types';
import ButtonFinePrint from '../components/ButtonFinePrint';
import ButtonBlock from '../components/ButtonBlock';
import Container from '../components/Container';
import introImage from '../assets/images/intro.png';
import { useDimensions } from '../hooks';



function Intro(props: TProps): React.Node {
  const onContinue = () => {
    if (props.navigation.current.state) {
      const { success_next_path, success_next_path_state } = props.navigation.current.state;
      if (success_next_path && success_next_path_state) return props.navigateTo(success_next_path, success_next_path_state);
    }

    const { path, state } = props.config.getNavTo(props.merchants.list);
    props.navigateTo(path, state);
  }
  const bottomActionRef = React.useRef(null);
  const bottomActionSize = useDimensions(bottomActionRef);
  const contentHeight = `calc(100vh - ${48 + bottomActionSize.height + 24}px)`;

  return (
    <Layout {...props} showLogo showExit>
      <Container height={contentHeight} overflow="scroll" px={24}>
        <Container height={contentHeight}>
          <Container flex centered mb={30} pt={30}>
            <img style={{ maxWidth: 80 }} alt="intro" src={introImage} />
          </Container>
          <TextHeader1 centered family="InterExtraLight">
            <TextStrong>{props.config.team_name}</TextStrong> uses <TextStrong>Method</TextStrong> to securely pay your accounts
          </TextHeader1>
          <Checklist
            items={[
              {
                title: 'Secure',
                description: 'Your information is handled securely with end-to-end encryption.',
              },
              {
                title: 'Private',
                description: `Your account number will not be shared with ${props.config.team_name}.`,
              },
            ]} />
        </Container>
        <Container absolute bottom={0} left={0} zIndex={100} width="100vw">
          <Container ref={bottomActionRef} fill="white">
            <Container ma={24}>
              <ButtonFinePrint onClick={() => {}}>
                <span>
                  By continuing, you agree to Method's <TextStrong>End User Privacy Policy</TextStrong>
                </span>
              </ButtonFinePrint>
              <ButtonBlock primary onClick={onContinue}>
                Continue
              </ButtonBlock>
            </Container>
          </Container>
        </Container>
      </Container>
    </Layout>
  );
}

// $FlowFixMe
export default Sentry.withProfiler(Intro, { name: 'Intro' });
